import { emptyList, emptyObject } from '@constants/empty';

export const getIsCreatingOrder = ({ checkout }) => checkout.creatingOrder;

export const getAllOfferList = ({ checkout }) => checkout.offerList;

export const getOfferList = (state, goalUID) =>
  getAllOfferList(state)[goalUID] || emptyList;

export const getOfferFaqs = ({ checkout }) => checkout.offerFaqs;

export const getCashResponse = ({ checkout }) => checkout.cashResponse;

export const getGenericSubscriptionData = ({ checkout }) =>
  checkout.subscriptionData?.subscription;

export const getGenericSubsciptionGoal = ({ checkout }) =>
  checkout.subscriptionData?.goal;

export const getAllPaymentMeta = ({ checkout }) =>
  checkout.paymentMeta || emptyObject;

export const getCustomPaymentMeta = (state, key) =>
  getAllPaymentMeta(state)[key];

export const getsubs = ({ checkout }) => checkout.purchaseSubscriptionResponse;

export const getEmiPlans = ({ checkout }) => checkout.emiPlans;

export const getPurchaseSubscription = ({ checkout }) =>
  checkout.purchaseSubscriptionResponse;

export const getExternalAppSubscription = (state) =>
  getPurchaseSubscription(state)?.user_subscription
    ?.external_app_subscriptions[0] ?? emptyObject;

export const getSubscriptionPricings = (state, goalUID) => {
  return state.checkout.pricings[goalUID];
};

export const getReferralError = ({ checkout }) => checkout.referralError;

export const getBundleDetails = (state, goalUID) =>
  state.checkout.bundleDetails[goalUID];

export const getDiscountedPricings = (state, goalUID) =>
  state.checkout.discountedPricings[goalUID];

export const getBundleAddOnsInfo = (state, selectedPricingUid) =>
  state.checkout.bundleAddOns[selectedPricingUid];

export const getBundleAddOnsInfoWithRef = (state, selectedPricingUid) =>
  state.checkout.bundleAddOnsWithRef[selectedPricingUid];

export const getBundleAddOnsRefError = ({ checkout }) =>
  checkout.bundleAddOnsRefError;

export const getBundleAddOns = ({ checkout }) => checkout.fetchingBundleAddOns;

export const getBatchGroupSubscription = ({ checkout }) =>
  checkout.batchGroupSubscription;

export const getPurchasedSubscription = (state, goalUID) =>
  state.checkout.purchasedSubscription?.[goalUID] || emptyList;

export const getOrderId = ({ checkout }) => checkout.orderId;

export const getPaymentStatusResponse = ({ checkout }) =>
  checkout.paymentStatusResponse;

export const getPartPaymentStatus = (state, goalUID) =>
  state.checkout.partPaymentStatus?.[goalUID] ?? emptyObject;

export const getExternalAppActivatedData = ({ checkout }) =>
  checkout.externalAppActivatedData;

export const getComboFeatures = ({ checkout }) => checkout.comboFeatures;
